import * as React from 'react';
import { ImageProps } from './types';
import { classes, st } from './Image.st.css';
import { WowImage } from '../WowImage/WowImage';

/** Image is a component to literally display an image - whether an absolute with full URL or a media platform item with relative URI */
export class Image extends React.Component<ImageProps> {
  render() {
    const { className, ...imageProps } = this.props;

    return <WowImage className={st(classes.root, className)} {...imageProps} />;
  }
}
